import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import LoadingSpinner from 'components/LoadingSpinner';
import {
  receiptCustomerRequest,
  customerPointActivitiesRequest,
} from 'actions/customers/list';
import TransactionDetailReceipt from 'components/receipt/transactions/TransactionDetailReceipt';
import ReceiptInvoices from 'pages/Reports/Invoices/ReceiptInvoices';

import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import styles from './PointActivity.css';
import List from './List';

class PointActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetail: false,
    };
  }

  render() {
    const { receiptData, pointActivities, customerDetail } = this.props;

    return (
      <PageWrapper>
        <div
          onClick={this.props.backToCustomerList}
          className={`${styles['go-back-section']}`}
        >
          <FontAwesome
            style={{ top: '-1px', position: 'relative' }}
            size="lg"
            name="angle-left"
          />
          <span style={{ fontSize: '15px' }}>{' Back to Customer List'}</span>
        </div>
        <div className={`${styles.header}`}>
          Point Activity -{' '}
          {customerDetail &&
            (customerDetail.name ||
              customerDetail.email ||
              customerDetail.phone)}
        </div>
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={this.state.showDetail}>
            <LoadingSpinner showLoadingSpinner={false} />
            <List
              getPointActivity={this._getPointActivity}
              pointActivities={pointActivities}
              openReceipt={this._openReceipt}
              customerDetail={this.props.customerDetail}
            />
          </LeftColumnWrapper>

          <RightColumnWrapper openRightColumn={this.state.showDetail}>
            <div className={styles['col-right-inner']}>
              <div className={styles['scrolled-area']}>
                {receiptData && receiptData.payment_type === 'invoice' && (
                  <div id="receipt-invoice-customer">
                    <ReceiptInvoices invoiceDetail={receiptData} />
                  </div>
                )}
                {receiptData && receiptData.payment_type !== 'invoice' && (
                  <div
                    id="receipt-transaction-customer"
                    className={styles['receipt-trx-container']}
                  >
                    <TransactionDetailReceipt paymentDetail={receiptData} />
                  </div>
                )}
              </div>
            </div>
            <div className={styles['mk-col-right-action-box-bottom']}>
              <button
                className="btn btn-primary pull-right"
                onClick={this._onClickDone}
              >
                Done
              </button>
            </div>
          </RightColumnWrapper>
        </ContentWrapper>
      </PageWrapper>
    );
  }

  _getPointActivity = params => {
    this.setState({ showDetail: false });
    this.props.customerPointActivitiesRequest(params);
  };

  _onClickDone = () => {
    this.setState({ showDetail: false });
  };

  _openReceipt = payment => {
    const { customerDetail } = this.props;
    this.props.receiptCustomerRequest(payment, customerDetail);
    this.setState({ showDetail: true });
  };
}

PointActivity.propTypes = {
  receiptData: PropTypes.object,
  customerDetail: PropTypes.object,
  pointActivities: PropTypes.object,
};

function mapStateToProps({
  customers: {
    list: { receiptData, customerDetail, pointActivities },
  },
}) {
  return { receiptData, customerDetail, pointActivities };
}

export default connect(
  mapStateToProps,
  { receiptCustomerRequest, customerPointActivitiesRequest }
)(PointActivity);
